/**
 * @fileoverview POST handler for the "/alloys/partners/google-postmaster/:app_group_id/connect" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysPartnersGooglePostmasterConnectCacheKeys } from "./constants";
import type {
  PostAlloysPartnersGooglePostmasterConnectProps,
  PostAlloysPartnersGooglePostmasterConnectResult,
} from "./types";

export const postAlloysPartnersGooglePostmasterAppGroupIdConnect = reactQueryMutationAdapter(
  postAlloysPartnersGooglePostmasterConnectCacheKeys,
  (
    props: PostAlloysPartnersGooglePostmasterConnectProps
  ): Promise<PostAlloysPartnersGooglePostmasterConnectResult> => {
    return fetch(`/alloys/partners/google-postmaster/${props.appGroupId}/connect`, "POST", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
